
import { Component, Vue, Prop, Watch } from "vue-property-decorator";
import Map from "../../Base/Map.vue";
import DeleteBox from "../../Base/DeleteBox.vue";
import ImageBox from "../../Base/ImageBox.vue";
import ImageSelector from "../../Base/ImageSelector.vue";
import BaseTable from "../../Base/BaseTable.vue";
import { GAMETYPE_ID, Season, Weapon } from "@/models/GameType";
import { forIn, cloneDeep, isEqual } from "lodash";

@Component({
  components: {
    Map,
    BaseTable,
    DeleteBox,
    ImageSelector,
    ImageBox,
  },
})
class GameTypeWeapons extends Vue {
  @Prop({ default: "EN" }) readonly languageID!: string;
  @Prop({ default: null }) readonly seasonData!: Season;
  @Prop({ default: false }) readonly isEditingLocked!: boolean;
  @Prop({ default: false }) readonly isSavedOrDiscard!: boolean;
  weaponSlug = "";
  showDetails = false;
  showSavePanel = false;
  seasonDataObject = {} as Season;
  showImageSelectorBool = false;

  get getTableData(): Weapon[] {
    const weaponArray: Weapon[] = [];
    forIn(this.seasonData.weapons, (val: Weapon) => {
      weaponArray.push(val);
    });
    return weaponArray;
  }
  get getSavePanelLock(): boolean {
    if (this.isSavedOrDiscard) {
      this.showSavePanel = false;
      return false;
    } else {
      return this.showSavePanel;
    }
  }

  get getWeaponData(): Weapon {
    if (this.weaponSlug !== "") {
      if (this.seasonData.weapons[this.weaponSlug] === undefined) {
        this.showDetails = false;
        return {} as Weapon;
      }
      return this.seasonData.weapons[this.weaponSlug];
    }
    return {} as Weapon;
  }

  get getGameTypeID(): GAMETYPE_ID {
    if (this.$store.state.gameStore.gameType.length > 0)
      return this.$store.state.gameStore.gameTypeSelected;
    return GAMETYPE_ID.MANHUNT;
  }

  get getImagePath(): string {
    return (
      "/gametype/" +
      this.getGameTypeID +
      "/seasons/" +
      this.seasonData.slug +
      "/img/weapons/"
    );
  }

  get getImage(): string {
    return this.seasonData.weapons[this.getWeaponData.uid].img;
  }

  created(): void {
    this.seasonDataObject = cloneDeep(this.seasonData);
  }

  deleteItem(slug: string): void {
    delete this.seasonData.weapons[slug];
    this.$store.dispatch("gameStore/updateSeasonType", this.seasonData);
    this.showDetails = false;
  }
  openDeleteBox(): void {
    this.$bvModal.show("team-modal-delete");
  }
  showImageSelector(): void {
    if (!this.isEditingLocked) {
      this.showImageSelectorBool = true;
    }
  }
  handleCloseButtonPress(): void {
    this.showImageSelectorBool = false;
  }

  returnImagePath(path: string): void {
    this.seasonData.weapons[this.getWeaponData.uid].img =
      this.getImagePath + "" + path;

    this.onValueChanged();
    this.showImageSelectorBool = false;
  }
  //Because the fxSlug might be different if the users swaps between games
  //We need to remove the show details so we don't keep an old screen up
  onRowSelected(row: Weapon): void {
    this.weaponSlug = row.uid;
    if (this.seasonData.weapons[this.weaponSlug] === undefined) {
      this.showDetails = false;
    } else {
      this.showDetails = true;
    }
  }
  onValueChanged(): void {
    var data = {
      type: "weapon",
      weapon: this.getWeaponData,
      selectable: true,
    };
    if (!isEqual(this.seasonData, this.seasonDataObject)) {
      this.showSavePanel = true;
    } else {
      this.showSavePanel = false;
    }
    this.$emit("updateTempObject", data);
  }

  @Watch("isEditingLocked")
  onIsEditingLockedChanged(value: boolean): void {
    if (value) {
      this.showSavePanel = false;
    }
  }
  clearImage(): void {
    if (!this.isEditingLocked) {
      this.seasonData.weapons[this.getWeaponData.uid].img = "";
      this.onValueChanged();
    }
  }
}

export default GameTypeWeapons;
